import { createTextVNode as _createTextVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  id: "__Layer_1",
  stroke: "currentColor",
  "data-name": "Layer 1",
  xmlns: "http://www.w3.org/2000/svg",
  width: "45",
  height: "45",
  viewBox: "0 0 45 45"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [
    _createElementVNode("defs", null, [
      (_openBlock(), _createBlock(_resolveDynamicComponent("style"), null, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(".__cls-1{fill:none;stroke-miterlimit:10;stroke-width:2px}")
        ])),
        _: 1
      }))
    ]),
    _cache[1] || (_cache[1] = _createStaticVNode("<g id=\"__Group_1750\" data-name=\"Group 1750\"><g id=\"__Group_1719\" data-name=\"Group 1719\"><circle id=\"__Ellipse_50\" data-name=\"Ellipse 50\" class=\"__cls-1\" cx=\"22.4992\" cy=\"22.4665\" r=\"4.9357\"></circle><path id=\"__Path_967\" data-name=\"Path 967\" class=\"__cls-1\" d=\"M14.2377,31.48a12.2261,12.2261,0,0,1,.099-18.1111\"></path><path id=\"__Path_968\" data-name=\"Path 968\" class=\"__cls-1\" d=\"M30.8789,13.561a12.223,12.223,0,0,1,.0582,17.7468\"></path><path id=\"__Path_969\" data-name=\"Path 969\" class=\"__cls-1\" d=\"M10.8987,35.5676a17.4944,17.4944,0,0,1-.0714-26.1352\"></path><path id=\"__Path_970\" data-name=\"Path 970\" class=\"__cls-1\" d=\"M34.333,9.5722a17.5,17.5,0,0,1-.0364,25.8192\"></path><circle id=\"__Ellipse_51\" data-name=\"Ellipse 51\" cx=\"22.4993\" cy=\"22.4665\" r=\"1.6112\"></circle></g></g>", 1))
  ]))
}
export default { render: render }